// 能耗分析
 import {
    Style
} from '@/libs/style.js';

let template = /*html*/ `<div class="app-nhmonitor">
<div class="app-nhmonitor-header">
    <img src="./images/default/2.png" alt="">
    <h4>能耗分析</h4>
</div>

</div>`;


let style = /* css */ `.app-nhmonitor{
    position: absolute;
    top: calc(560px + 100px);
    right: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 270px;
    overflow: hidden;
}

.app-nhmonitor .app-nhmonitor-header{
    background:linear-gradient(to right,#67BDFF,rgba(0,0,0,0) 50%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
}
.app-nhmonitor .app-nhmonitor-header img{
    margin:0 15px;
}

.app-nhmonitor .tab-section{
    padding:0 20px;
    color:#fff;
}
.app-nhmonitor .tab-item{
    color:#fff;
}
.app-nhmonitor .el-tabs__item{
    color:#fff;
}
`;

export default (Vue) => {
    Vue.customElement('app-nhmonitor', {
        template: template,
        data() {
            return {
                activeName: 'malfunction'
            }
        },
        mounted() {
            Style(style);
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            }
        }
    });
}